export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-unlink-46236de6ffafa057934241873f0ab6dd.svg";